var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0852 12.7554C12.9948 12.7554 12.9096 12.713 12.8551 12.6408L10.7571 9.86146L10.6705 10.2325L6.82532 26.0304C6.35367 27.9682 4.61793 29.3322 2.62354 29.3322H2.42107C2.32771 29.3322 2.25898 29.2448 2.28098 29.1541L7.80176 6.39L7.88253 6.05346L7.88183 6.05253L8.00528 5.54197L8.6427 2.88606C8.67381 2.75643 8.78973 2.66504 8.92304 2.66504H9.61743C9.7073 2.66504 9.79202 2.70694 9.84656 2.77837L11.8237 5.36747L11.8202 5.38148L17.235 12.5242C17.3069 12.6191 17.2392 12.7554 17.1201 12.7554H13.0852Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5984 18.6117C26.7586 18.3378 29.9809 14.8766 29.9809 10.6471C29.9809 6.23878 26.4073 2.66511 21.999 2.66504H13.9882C13.7501 2.66504 13.6146 2.93723 13.7581 3.12715L15.7785 5.80062C15.8057 5.83667 15.8483 5.85786 15.8935 5.85786H21.9989C24.6438 5.85794 26.7881 8.00212 26.7881 10.6471C26.7881 13.2921 24.6439 15.4363 21.9989 15.4363H11.7941C11.5564 15.4363 11.4208 15.7078 11.5636 15.8978L12.7266 17.4454C13.2698 18.1682 14.1206 18.5943 15.0248 18.5964L17.3967 18.6017L24.1846 27.6102C25.0017 28.6945 26.2806 29.3322 27.6383 29.3322H29.6959C29.8152 29.3322 29.8829 29.1956 29.8106 29.1007L21.8212 18.6117L21.8242 18.6117H22.5984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ac0370170c0234381b06af8e87fcce09.svg";
export { ForwardRef as ReactComponent };